import Image from 'next/image';

import { StyledH2, StyledParagraph } from '../../SwapTokens/utils';
import { CheckMarkList } from '../utils';
import { TransactionModuleCell } from './TransactionModuleCell';

export function SwapTokensBenefitsSection() {
  return (
    <>
      <div
        className="bg-token-gray-100 border border-token-gray-300 border-solid overflow-hidden rounded-lg pt-11 tablet:pt-15 px-11 tablet:px-15 w-full mx-auto mb-5 flex justify-center max-w-[1240px] flex-col items-center desktop:flex-row desktop:justify-between desktop:items-start pl-4 pr-4 desktop:pt-[54px] desktop:pl-15 desktop:pr-20"
        style={{
          background:
            'url(/images/swap-tokens/diagonal-lines.svg) no-repeat left top, var(--token-color-gray-100)',
        }}
      >
        <div className="mr-7 desktop:mr-10 ml-7 desktop:ml-0 desktop:flex-shrink-0 max-w-[377px]">
          <StyledH2>The best trade prices are on Matcha.</StyledH2>
          <StyledParagraph className="mb-[42px]">
            How can traders like you get the best prices?
          </StyledParagraph>
          <CheckMarkList
            items={[
              'Scouts everywhere for best price',
              'Protects you against sandwich attacks',
              'Slippage and price impact warnings',
            ]}
          />
        </div>
        <TransactionModuleCell />
      </div>
      <div className="tablet:flex gap-5 max-w-[1240px] mx-auto">
        <div
          className="border border-token-gray-300 overflow-hidden rounded-lg px-11 tablet:px-15 w-full mx-auto mb-5 flex justify-between max-w-[1240px] flex-col pb-14 tablet:pb-7.5 pr-11 desktop:pr-12 pt-15 tablet:pt-12 items-start tablet:flex-[53%] desktop:flex-[40%]"
          style={{
            background:
              'url(/images/swap-tokens/diagonal-lines.svg) no-repeat left top, var(--token-color-gray-100)',
          }}
        >
          <div className="px-5 tablet:px-0">
            <StyledH2 className="mb-8">MEV protection</StyledH2>
            <CheckMarkList
              items={[
                'RFQ private settlement',
                'No public mempool - no MEV bots!',
                'Enhanced protection with Matcha Auto',
              ]}
            />
          </div>
          <Image
            src="/images/swap-tokens/shield.svg"
            className="mt-4 self-end tablet:w-[104px] h-auto"
            alt=""
            width={132}
            height={141}
          />
        </div>
        <div className="border border-token-gray-300 border-solid overflow-hidden rounded-lg tablet:pt-12 px-11 tablet:px-15 w-full mx-auto mb-5 bg-token-gray-100 flex justify-center max-w-[1240px] flex-col items-center pb-15 tablet:pb-9 desktop:pb-[58px] desktop:items-start pr-8 desktop:pr-[54px] pt-15 tablet:flex-[47%] desktop:flex-[60%]">
          <div className="pl-5 tablet:pl-0 pr-7">
            <StyledH2 className="mb-8">Smart Routing</StyledH2>
            <CheckMarkList
              items={[
                'Matcha sources the market for the best prices',
                'Statistical models by 0x optimize trade routes',
                'Split trades across multiple sources',
              ]}
            />
          </div>
          <Image
            src="/images/swap-tokens/routes.svg"
            className="mt-[52px] ml-15 tablet:ml-0 self-end tablet:self-start desktop:self-end border border-solid"
            alt=""
            width={227}
            height={103}
          />
        </div>
      </div>
    </>
  );
}
